<template>
  <v-dialog v-model="showDialog" persistent max-width="1300px">
    <v-card>
      <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
      </v-card-title>-->
      <v-toolbar color="primary darken-4" dark>
        <img
          :src="$store.state.iconoForm"
          height="42"
          alt="Acciones tipo producto"
        />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="formBitacoraRenta" :v-model="true" lazy-validation>
            <v-layout wrap class="container">
              <v-layout row my-4>
                <v-flex xs12 sm6 md5 lg5>
                  <div>Renta: {{ renta.folioRenta }}</div>
                  <div>Cliente: {{ renta.cliente.nombreCompletoCliente }}</div>
                </v-flex>

                <v-flex xs12 sm6 md3 lg3 class="text-xs-right">
                  <h4>SALDO PENDIENTE</h4>
                </v-flex>

                <v-flex xs12 sm6 md2 lg2 class="text-xs-right">
                  <h4>
                    <span class="red--text">
                      <b>$ {{ formatMoney(totalRestante) }}</b>
                    </span>
                  </h4>
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md2
                  lg2
                  class="text-xs-right"
                  v-if="totalRestante > 0"
                >
                  <v-btn
                    color="success"
                    dark
                    fab
                    small
                    slot="activator"
                    class="v-btn-30"
                    title="Agregar pago a renta"
                    @click="openDialogPago"
                  >
                    <v-icon dark>add</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12 sm8 md8 lg8>
                  <v-select
                    v-model="rentaBitacora.eventoRentaId"
                    :items="eventosRenta"
                    item-text="descripcion"
                    item-value="eventoRentaId"
                    label="Evento renta"
                    placeholder="Evento renta"
                    hint="Evento renta"
                    single-line
                    :rules="[
                      () =>
                        !!rentaBitacora.eventoRentaId ||
                        'El campo es requerido',
                    ]"
                    required
                    :readonly="readOnly"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm4 md4 lg4>
                  <v-menu
                    ref="menuFechaEvento"
                    :close-on-content-click="false"
                    v-model="openFechaEvento"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="rentaBitacora.fechaEvento"
                      label="Fecha"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      ref="picker"
                      v-model="rentaBitacora.fechaEvento"
                      min="2018-01-01"
                      @change="setFechaEvento"
                      locale="es"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  label="Comentarios"
                  v-model="rentaBitacora.comentarios"
                  placeholder="Comentarios"
                  hint="Comentarios"
                  :counter="120"
                ></v-text-field>
              </v-flex>

              <v-layout v-if="rentaBitacora.eventoRentaId === 5">
                <v-flex xs6 sm6 md4 lg4>
                  <v-checkbox
                    v-model="credencialElector"
                    label="Credencial de Elector"
                    color="primary"
                    :value="credencialElector"
                    hide-details
                    @change="completarAnexos"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs6 sm6 md4 lg4>
                  <v-checkbox
                    v-model="licenciaConducir"
                    label="Licencia de conducir"
                    color="primary"
                    :value="licenciaConducir"
                    hide-details
                    @change="completarAnexos"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs6 sm6 md4 lg4>
                  <v-checkbox
                    v-model="comprobanteDomicilio"
                    label="Comprobante domicilio"
                    color="primary"
                    :value="comprobanteDomicilio"
                    hide-details
                    @change="completarAnexos"
                  ></v-checkbox>
                </v-flex>
              </v-layout>

              <v-flex
                xs12
                sm12
                md12
                lg12
                v-if="rentaBitacora.eventoRentaId === 5"
              >
                <v-text-field
                  label="Anexos"
                  v-model="rentaBitacora.anexoEvento"
                  placeholder="Anexos"
                  hint="Anexos"
                  :counter="120"
                ></v-text-field>
              </v-flex>

              <v-layout v-if="rentaBitacora.eventoRentaId === 8">
                <v-flex xs12>
                  <v-data-table
                    :headers="desgloseProductos.header"
                    :items="desgloseProductos.data"
                    hide-actions
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.sku }}</td>
                      <td>{{ props.item.descripcionProducto }}</td>
                      <td>{{ props.item.descripcionTalla }}</td>
                      <td>
                        <v-icon :color="props.item.codigoHtml">widgets</v-icon>
                        <span class="cb-item">{{
                          props.item.nombreColor
                        }}</span>
                      </td>
                      <td>{{ props.item.cantidad }}</td>
                      <td>
                        <v-text-field
                          label="Cantidad a tintorería"
                          v-model="props.item.cantidadTintoreria"
                          type="number"
                          :rules="[
                            () =>
                              props.item.cantidadTintoreria >= 0 ||
                              'No puede ser negativo!',
                            () =>
                              props.item.cantidadTintoreria <=
                                props.item.cantidad ||
                              'No puede ser mayor a la cantidad solicitada!',
                          ]"
                          @change="updateDetalleProducto(props.item)"
                        ></v-text-field>
                      </td>
                      <td>
                        <v-text-field
                          label="Cantidad devuelta"
                          v-model="props.item.cantidadDevuelta"
                          type="number"
                          :rules="[
                            () =>
                              props.item.cantidadDevuelta >= 0 ||
                              'No puede ser negativo!',
                            () =>
                              props.item.cantidadDevuelta <=
                                props.item.cantidad ||
                              'No puede ser mayor a la cantidad solicitada!',
                          ]"
                          @change="updateDetalleProducto(props.item)"
                        ></v-text-field>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-form>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false">Cerrar</v-btn>
        <v-btn
          color="primary darken-4"
          :loading="$store.state.operationInProgress"
          @click="saveRentaBitacora"
          >Guardar</v-btn
        >
      </v-card-actions>
      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
        >Bitácora guardada con éxito</v-alert
      >
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
    <confirm ref="confirm"></confirm>
    <form-pago-renta
      :renta="renta"
      :rentaPago="rentaPago"
      :nuevoPago="nuevoPago"
      ref="dialogPagoRenta"
      @onPagoAdded="onPagoAdded"
    ></form-pago-renta>
  </v-dialog>
</template>

<script>
import moment from "moment";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

import confirm from "@/components/dialogs/Confirm";
import formPagoRenta from "@/views/renta-pagos/FormPagoRenta";

//Services
import rentaService from "@/services/rentaService";
import rentaPagoService from "@/services/rentaPagoService";

export default {
  components: {
    loadingAlert,
    snackBar,
    confirm,
    formPagoRenta,
  },
  props: {
    rentaBitacora: {
      type: Object,
      required: true,
    },
    nuevoEvento: {
      type: Boolean,
      required: true,
    },
    renta: {
      type: Object,
      required: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.getEventosRenta();
  },
  data() {
    return {
      showDialog: false,
      eventosRenta: [],
      openFechaEvento: false,
      anexosEvento: [
        "credencialElector",
        "licenciaConducir",
        "comprobanteDomicilio",
      ],
      credencialElector: false,
      licenciaConducir: false,
      comprobanteDomicilio: false,
      rentaPago: {
        rentaId: this.renta.rentaId,
        numPago: 0,
        fechaPago: moment(new Date()).format("YYYY-MM-DD"),
        horaPago: moment(new Date()).format("H:mm"),
        montoPago: 0.0,
        conceptoPagoId: null,
        formaPagoId: null,
        referenciasPago: "",
        observaciones: "",
        cambioDevuelto: 0,
      },
      nuevoPago: true,
      desgloseProductos: {
        header: [
          { text: "SKU", align: "center", sortable: true, value: "sku" },
          {
            text: "PRODUCTO",
            align: "center",
            sortable: false,
            value: "descripcionProducto",
          },
          {
            text: "TALLA",
            align: "center",
            sortable: false,
            value: "descripcionTalla",
          },
          {
            text: "COLOR",
            align: "center",
            sortable: false,
            value: "nombreColor",
          },

          {
            text: "CANTIDAD",
            align: "center",
            sortable: false,
            value: "cantidad",
          },
          {
            text: "A TINTORERÍA",
            align: "center",
            sortable: false,
            value: "cantidadTintoreria",
          },
          {
            text: "A INVENTARIO",
            align: "center",
            sortable: false,
            value: "cantidadDevuelta",
          },
        ],
        data: [],
      },
    };
  },
  watch: {
    renta: function (n) {
      this.desgloseProductos.data = n.desgloseProductos;
    },
  },
  computed: {
    totalRestante: function () {
      return this.renta.totalFinal - this.renta.pagado;
    },
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    getEventosRenta() {
      let self = this;
      self.loadingProductos = true;
      rentaService
        .getEventos()
        .then((result) => {
          self.eventosRenta = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingProductos = false;
        });
    },
    setFechaEvento(date) {
      this.$refs.menuFechaEvento.save(date);
    },
    saveRentaBitacora() {
      let self = this;

      if (self.totalRestante > 0) {
        this.$refs.confirm
          .open(
            "SALDO PENDIENTE",
            "Hay un saldo pendiente restante, ¿Realmente quieres continuar?",
            { color: "red" }
          )
          .then((confirm) => {
            if (confirm) {
              self.applicarRentaBitacora();
            } else {
              self.$store.state.snackbar.color = "error";
              self.$store.state.snackbar.text = "Operación cancelada";
              self.$store.state.snackbar.visible = true;
            }
          });
      } else {
        self.applicarRentaBitacora();
      }
    },
    applicarRentaBitacora() {
      let self = this;
      rentaService
        .addBitacora(self.rentaBitacora)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onBitacoraAdded", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 1500);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    resetForm() {
      let self = this;
      self.rentaBitacora.rentaId = 0;
      self.rentaBitacora.eventoRentaId = 5;
      self.rentaBitacora.fechaEvento = moment(new Date()).format("YYYY-MM-DD");
      self.rentaBitacora.comentarios = "";
      self.rentaBitacora.anexoEvento = "";
      self.operationReset();
      self.$refs.formBitacoraRenta.resetValidation();
    },
    completarAnexos() {
      let anexos = "";

      if (this.credencialElector) {
        anexos += "CREDENCIAL DE ELECTOR (INE), ";
      }
      if (this.licenciaConducir) {
        anexos += "LICENCIA DE CONDUCIR, ";
      }
      if (this.comprobanteDomicilio) {
        anexos += "COMPROBANTE DE DOMICILIO, ";
      }

      let lengthAnexos = anexos.length;
      var newAnexos = anexos.substring(0, lengthAnexos - 2);
      this.rentaBitacora.anexoEvento = newAnexos;
    },
    openDialogPago() {
      let self = this;

      self.$store.state.tituloForm = "AGREGAR PAGO";
      self.$store.state.iconoForm = "/images/general/agregar-40.png";
      self.$refs.dialogPagoRenta.resetForm();

      rentaPagoService.getPagos(self.renta.rentaId).then((result) => {
        self.rentaPago.numPago = result.length + 1;
      });

      self.rentaPago.horaPago = moment(new Date()).format("H:mm");
      self.$refs.dialogPagoRenta.openDialog();
      self.nuevoPago = true;
    },
    onPagoAdded(rentaPago) {
      this.renta.pagado += rentaPago.montoPago;
      this.$emit("onPagoAdded", rentaPago);
    },
    updateDetalleProducto(detalleProducto) {
      let self = this;
      detalleProducto.rentaId = self.renta.rentaId;
      let sumaCantidades =
        Number(detalleProducto.cantidadTintoreria) +
        Number(detalleProducto.cantidadDevuelta);
      let cantidadTintoreria = Number(detalleProducto.cantidadTintoreria);
      let cantidadDevuelta = Number(detalleProducto.cantidadDevuelta);
      let datosValidos = true;

      if (cantidadTintoreria > detalleProducto.cantidad) {
        self.$store.state.snackbar.color = "warning";
        self.$store.state.snackbar.text =
          "La cantidad en tintorería excede a la cantidad entregada";
        self.$store.state.snackbar.visible = true;
        detalleProducto.cantidadTintoreria = 0;
      }

      if (cantidadDevuelta > detalleProducto.cantidad) {
        datosValidos = false;
        self.$store.state.snackbar.color = "warning";
        self.$store.state.snackbar.text =
          "La cantidad edevuelta excede a la cantidad entregada";
        self.$store.state.snackbar.visible = true;
        detalleProducto.cantidadDevuelta = 0;
      }

      if (sumaCantidades > detalleProducto.cantidad) {
        datosValidos = false;
        detalleProducto.cantidadTintoreria = 0;
        detalleProducto.cantidadDevuelta = 0;
        self.$store.state.snackbar.color = "warning";
        self.$store.state.snackbar.text =
          "Las cantidades no cuadran con la solicitada!";
        self.$store.state.snackbar.visible = true;
      }

      rentaService
        .updateDetalleRentaEntrega(detalleProducto)
        .then((result) => {})
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });

      if (datosValidos) {
        self.$store.state.snackbar.color = "success";
        self.$store.state.snackbar.text = "Información actualizada!";
        self.$store.state.snackbar.visible = true;
      }
    },
  },
};
</script>

<style>
.v-btn-30 {
  height: 30px !important;
  width: 30px !important;
}
</style>
